<template>
  <q-select
    v-model="terms"
    :class="{ required: required }"
    dense
    outlined
    :clearable="$attrs.clearable !== false"
    use-input
    emit-value
    map-options
    options-dense
    fill-input
    hide-selected
    hide-bottom-space
    :options="currenciesOptions"
    :label="getLabel"
    :error="error"
    :error-message="errorMessage"
    :disable="disable"
    :readonly="readonly"
    @filter="search"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
        <q-item-section>
          <q-item-label v-html="scope.opt.label" />
          <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">
          {{ $t('Common.NoResult.Text') }}
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CurrencyField',
  props: {
    value: {},
    label: {
      type: String,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: false,
    },
    selectDefault: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: [Object, Boolean],
    },
  },
  data: () => ({
    terms: '',
    currenciesOptions: [],
  }),
  watch: {
    terms: {
      handler(to) {
        this.$emit('input', to)
        this.$emit('callback')
      },
    },
    selected: {
      handler(to) {
        this.currenciesOptions.push(to)
        this.terms = to.value || null
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getCurrencyListOptions']),
    getLabel() {
      return this.label || this.$ts('terms.currency')
    },
  },
  async mounted() {
    await this.getCurrencyListAction()
    if (this.selectDefault && !this.selected) {
      this.currenciesOptions = [...this.getCurrencyListOptions]
      this.terms = this.value ? this.value : this.$helpers.getValue(this.currenciesOptions, '[0].value', null)
    }
  },
  methods: {
    ...mapActions(['getCurrencyListAction']),
    async search(terms, update) {
      let filterOptions = [...this.getCurrencyListOptions]
      if (this.selected) {
        filterOptions = [...filterOptions, ...[this.selected]]
      }
      if (terms !== '') {
        update(() => {
          this.currenciesOptions = filterOptions.filter(x => x.label.includes(terms))
        })
      } else {
        update(() => {
          this.currenciesOptions = filterOptions
        })
      }
    },
  },
}
</script>
